import { useResourcePermissionWithoutSuperCheck } from "common/components/permissionChecker";

export function useThreadPermission({
  type,
  thread,
  threadId,
  contentOwnerId,
}: {
  type: Moim.Permission.PermissionType;
  thread: Moim.Forum.IThread;
  contentOwnerId?: Moim.Id;
  threadId?: Moim.Id;
}) {
  return useResourcePermissionWithoutSuperCheck(
    type,
    thread.id ?? threadId,
    contentOwnerId ?? thread.author,
  );
}
